<div
  *ngIf="control?.touched && control?.invalid"
  class="text-red-500 text-sm mt-1"
>
  <ng-container *ngFor="let key of errorKeys">
    <div>
      {{ errorMessages[key](control?.errors?.[key]) || 'Error desconocido' }}
    </div>
  </ng-container>
</div>
